class LangMenu {
    // 1. describe and create/initiate our object
    constructor() {
        this.langMenu = document.querySelector('#lang-menu');
        this.langMenuMobile = document.querySelector('#lang-menu-mobile');
        this.langMenuArrow = document.querySelector('.header__lang-menu--icon');
        if (this.langMenu && this.langMenuMobile && this.langMenuArrow) {
            this.events();
        }
    }

    // 2. events
    events() {
        this.langMenuArrow.addEventListener("click", (e) => {
            this.handleArrowClick(e);
        });

        this.langMenu.addEventListener("click", (e) => {
            this.handleLangMenuClick(e);
        });

        this.langMenuMobile.addEventListener("click", (e) => {
            this.handleLangMenuClick(e);
        });

        document.addEventListener("click", (e) => {
            this.handleDocumentClick(e);
        });
    }

    // 3. methods (function, action...)
    handleLangMenuClick(event) {
        if (!this.langMenu.classList.contains("expand") || !this.langMenuMobile.classList.contains("expand")) {
            event.preventDefault();
            this.langMenu.classList.toggle("expand");
            this.langMenuMobile.classList.toggle("expand");
        }
        event.stopPropagation();
    }

    handleArrowClick(event) {
        if (this.langMenu.classList.contains("expand") || this.langMenuMobile.classList.contains("expand")) {
            this.langMenu.classList.remove("expand");
            this.langMenuMobile.classList.remove("expand");
            event.stopPropagation();
        }
    }

    handleDocumentClick(event) {
        if (!this.langMenu.contains(event.target) && !this.langMenuMobile.contains(event.target)) {
            this.langMenu.classList.remove("expand");
            this.langMenuMobile.classList.remove("expand");
        }
    }
}

export default LangMenu;
